import { createFileRoute } from '@tanstack/react-router'

import Terms from '@/features/Auth/Terms'
import { RouteErrorComponent } from '@/shared/RouteErrorComponent/RouteErrorComponent.tsx'

export const Route = createFileRoute('/_public/terms')({
    component: RouteComponent,
    onError: RouteErrorComponent,
})

function RouteComponent() {
    return <Terms />
}
